import React from "react";
import "./LikedStories.css";
import StoryList from "../Home/StoryList/StoryList";
import { fetchLikedStories } from "../../config/data";

const LikedStories = () => {
  const [likedStories, setLikedStories] = React.useState([]);
  const [searchKey, setSearchKey] = React.useState("");
  const [expandedSection, setExpandedSection] = React.useState("");

  React.useEffect(() => {
    const loadData = async () => {
      const data = await fetchLikedStories();
      setLikedStories(data);
    };
    loadData();
  }, []);
  const toggleSection = (section) => {
    console.log("section", section);
    setExpandedSection(expandedSection === section ? null : section);
  };

  return (
    <div className="likedStories">
      <div className="accordionSection">
        <button className="accordionTitle" onClick={() => toggleSection("")}>
          Liked Stories
        </button>
        {expandedSection === "" && (
          <div className="accordionContent">
            {!likedStories.length ? (
              <p>No stories found</p>
            ) : (
              <StoryList stories={likedStories} />
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default LikedStories;
